import axios from "axios";



export const adminLogin = async ({ username, password }) => {

  const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/user/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',

    },
    body: JSON.stringify({ username, password }),
  });

  const data = await res.json();


  // Check both HTTP status and response body `status` field
  if (!res.ok || data?.status === false) {
    const errorMessage = data?.message || 'Login failed';

    throw errorMessage;
  }

  return data;
};


export const adminChangePassword = async ({ id, password, confirmPassword }) => {
  const token = sessionStorage.getItem("token");

  const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/admin/changePassword/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ password, confirmPassword }),
  });

  const data = await res.json();



  if (!res.ok || data?.status === false) {
    const errorMessage = data?.message || 'Login failed';

    throw errorMessage;
  }

  return data;
};




export const fetchCategories= async (page, limit, searchTerm) => {
  const token = sessionStorage.getItem("token");
  const res = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/category/parent-categories?page=${page}&limit=${limit}&search=${searchTerm}`,
    {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  );
  return res;
};

export const fetchCategoriesForSort= async () => {
  const token = sessionStorage.getItem("token");
  const res = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/category/list-parent-categories/names`,
    {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  );
  return res;
};
export const fetchSubCategories= async (id,page, limit, searchTerm) => {
  const token = sessionStorage.getItem("token");
  const res = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/category/${id}?page=${page}&limit=${limit}&search=${searchTerm}`,
    {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  );
  return res;
};

export const fetchSubCategoriesForSort= async (id) => {
  const token = sessionStorage.getItem("token");
  const res = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/category/${id}/list-sub-categories/names`,
    {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  );
  return res;
};

export const fetchProducts= async (id,page, limit, searchTerm) => {
  const token = sessionStorage.getItem("token");
  const res = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/product/category/${id}?page=${page}&limit=${limit}&search=${searchTerm}`,
    {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  );
  return res;
};

export const fetchProductsForSort= async (id) => {
  const token = sessionStorage.getItem("token");
  const res = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/product/category/${id}/names`,
    {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  );
  return res;
};

export const fetchImages= async (id) => {
  const token = sessionStorage.getItem("token");
  const res = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/category/list-images/all`,
    {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  );
  return res;
};


export const fetchWebConfig= async () => {
  const token = sessionStorage.getItem("token");
  const res = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/cms/get`,
    {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  );
  return res;
};


export const updateWebConfig = async (formData) => {
  const token = sessionStorage.getItem("token");

  const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/cms/update-common-settings`, {
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  const data = await res.json();

  if (!res.ok || data?.status === false) {
    const errorMessage = data?.message || "Cannot Update Website Settings";
    throw new Error(errorMessage);
  }

  return data;
};







